import mediaGalleryContentLoaderOptions from '@/js/App/PdModal/mediaGalleryContentLoaderOptions'
import PdModal, { HTMLContentLoader, MediaGalleryContentLoader, NajaContentLoader } from '@peckadesign/pd-modal'

export default function registerContentLoaders(modal: PdModal) {
	modal.registerContentLoader(new HTMLContentLoader(modal))
	modal.registerContentLoader(new NajaContentLoader(modal))

	const mediaGalleryContentLoader = new MediaGalleryContentLoader(modal, mediaGalleryContentLoaderOptions)
	mediaGalleryContentLoader.classList.push('pd-modal--bg-content')
	modal.registerContentLoader(mediaGalleryContentLoader)
}
